import React, { useLayoutEffect, useState } from 'react';
import { View, Text, TextInput, ImageBackground } from 'react-native';
import GlobalStyles from './../style';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = undefined;

const SendTeam = () => {
  let [teamData, onChangeTeamData] = React.useState("");

  const navigation = useNavigation();
  useLayoutEffect(() => {
    navigation.setOptions({
      //headerShown: false,
      headerTitle: transl('MainMenu.enviarAmigo', lang)
    })
  }, []);

  //receivedData
  const [value, setvalue] = useState('');
  const readValue = () => {
    AsyncStorage.getItem('equipos')
      .then((value) => {
        setvalue(value)
        setMyTeam(value)
      })
  }
  readValue();

  lang = dr.idiomas[useSelector((state) => state.language)].value

  teamData = setMyTeam(value)

  return (
    <ImageBackground source={require('./../img/background4.png')} resizeMode="cover" style={{ flex: 1 }}>
      <View style={{ marginTop: 'auto', marginBottom: 'auto' }}>
        <Text style={{ marginHorizontal: 10, marginTop: 25 }}>{transl('SendTeam.esteEsTuEquipo', lang)}</Text>
        <View style={[GlobalStyles.buttonMargins]}>
          <Text style={{ textAlign: 'center' }}>{transl('SendTeam.tusDatos', lang)}</Text>
          <TextInput
            style={[GlobalStyles.input,{backgroundColor:'white'}]}
            onChangeText={onChangeTeamData}
            value={teamData}
          />
        </View>
      </View>
    </ImageBackground>
  )
}

function setMyTeam(value) {
  if (value === undefined || !value) {
    return transl('General.cargando', lang)
  }
  if (typeof value != "object") value = value != null ? JSON.parse(value) : null

  let finalPlayers = value.teams[0].players.slice(0, 7).map(player => ({
    name: player.name,
    broom: player.broom,
    skills: player.skills,
    hiddenSkills: player.hiddenSkills,
    nickname: player.nickname,
    age: player.age
  }));
  finalPlayers = {
    players: finalPlayers,
    info: {
      uuid: value.profile.uuid,
      name: value.profile.managerName,
      trophies: value.others.trophies,
      teamName: value.teams[0].name
    }
  }
  finalPlayers = JSON.stringify(finalPlayers)
  let CryptoJS = require("crypto-js");
  let ciphertext = CryptoJS.AES.encrypt(finalPlayers, 'quidditch');

  //if(Clipboard != null) Clipboard.setString(ciphertext.toString());

  return ciphertext.toString()
}

export default SendTeam